import type { ExperimentAssignment, ExperimentsData } from '@/components/_shared/contexts/ExperimentsContext';
import { LISTINGS_DESKTOP_TWO_RAILS_EXPERIMENT } from '../../common/constants';

export function isListingsDesktopTwoRailsVariant(assignment: ExperimentAssignment | undefined): boolean {
  return assignment?.groupName?.toLowerCase() === 'test';
}

function getClientSideOverride(searchParams?: string): boolean | null {
  if (typeof window === 'undefined') {
    return null; // Server-side, no override
  }

  const search = searchParams ?? window.location.search;
  const urlParams = new URLSearchParams(search);
  const override = urlParams.get('override_desktop_two_rails');

  if (override?.toLowerCase() === 'test') return true;
  if (override?.toLowerCase() === 'control') return false;

  return null;
}

export function getListingsDesktopTwoRailsFromExperiments(
  experiments: ExperimentsData | undefined,
  searchParams?: string,
): boolean {
  // Check for client-side override
  const override = getClientSideOverride(searchParams);
  if (override !== null) {
    return override;
  }

  if (!experiments) {
    return false;
  }
  return isListingsDesktopTwoRailsVariant(experiments[LISTINGS_DESKTOP_TWO_RAILS_EXPERIMENT.experimentName]);
}

// Server-safe version that only uses experiment data (no URL overrides)
export function getListingsDesktopTwoRailsFromExperimentsSSR(experiments: ExperimentsData | undefined): boolean {
  if (!experiments) {
    return false;
  }
  return isListingsDesktopTwoRailsVariant(experiments[LISTINGS_DESKTOP_TWO_RAILS_EXPERIMENT.experimentName]);
}
